import { colors } from "./colors";
import { breakpoints, mediaBreakpoints } from "./breakpoints";
import { fonts } from "./fonts";

export const globals = {
  colors,
  fonts,
  mediaBreakpoints,
  breakpoints,
};
